import { apiOperacao } from "../../api";
import { IEmpresa } from "../../model";
import { toast } from "react-toastify";
import { TarefasStore } from "../notas/TarefasStore";
import { NFesStore } from "../nfe/NFesStore";
import * as utils from "../../utils";

export class _XmlService {

  async downloadXml(operacao: string, documento: any, razao_social: string) {

    try {

      let resp = await apiOperacao(operacao).post(`/${operacao}/download`, documento, { responseType: 'blob' });

      if (resp.status == 200) {

        const name = this.nameFile(documento, razao_social, "")

        utils.downloadBinaryFile(resp.data, name)

      } else {

        toast.error(utils.decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao realizar download XMLs, tente novamente mais tarde.`);

    }

  }

  async download_eventos(operacao: string,documento: any, razao_social: string) {

    try {

      let resp = await apiOperacao(operacao).post(`/${operacao}/download-evento`, documento, { responseType: 'blob' });

      if (resp.status == 200) {

        const name = this.nameFile(documento, razao_social, "-Eventos")

        utils.downloadBinaryFile(resp.data, name)

      } else {

        toast.error(utils.decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao realizar download do Eventos XMLs, tente novamente mais tarde.`);

    }

  }

  async download_danfe(operacao: string, documento: any, razao_social: string): Promise<void> {

    try {

      let resp = await apiOperacao(operacao).post(`/${operacao}/danfe-download`, documento, { responseType: 'blob' });

      if (resp.status === 200 && documento.tipo === "NFS-E") {

        toast.success("Solicitação de DANFSe realizada com sucesso!", {});

        await TarefasStore.handleTasksPaged(1)

        NFesStore.obs.selectedTab = "tarefas"

      } else if (resp.status === 200) {

        const name = this.nameFile(documento, razao_social, "-PDF");

        utils.downloadBinaryFile(resp.data, name);

      } else {

        toast.error(utils.decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao realizar download da DANFE, tente novamente mais tarde.`);

    }

  }

  async view_xml(operacao: string, chave: any, entrada_saida: string, modelo: string, dhemi: string, cnpj: string): Promise<void> {

    try {

      let data = { chave: chave, entrada_saida: entrada_saida, modelo: modelo, dhemi: dhemi, cnpj: cnpj };

      let resp = await apiOperacao(operacao).post(`/${operacao}/requisicao-download-xml`, data);

      if (!resp.data.ok) {
        toast.error('Não foi possível realizar o download.', {});
      } else {
        const linkSource = `data:application/xml;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${chave}.xml`;
        downloadLink.click();
      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao baixar XML, tente novamente mais tarde.`);

    }

  }

  async downloadDanfeNotas(operacao: string, empresa: IEmpresa, data: any) {

    try {

      let resp = await apiOperacao(operacao).post(`/${operacao}/danfe-download`, data);

      if (resp.status == 200 && data.tipo === "NFS-E") {

        toast.success("Solicitação de DANFSe realizada com sucesso!", {});

        await TarefasStore.handleTasksPaged(1)

        NFesStore.obs.selectedTab = "tarefas"

      } else if (resp.status == 200) {

        let linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = utils.nameFile(empresa, `${data.data1}_${data.data2}`);
        downloadLink.click();

      } else {

        toast.error(utils.decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao realizar download da DANFE, tente novamente mais tarde.`);

    }

  }

  /**
 * Realiza o download do DANFE (Documento Auxiliar da Nota Fiscal Eletrônica) em formato PDF.
 * 
 * Este método faz uma requisição à API para gerar o DANFE em formato base64 e, em seguida, cria um link de download
 * para o usuário baixar o arquivo PDF. Se houver erro na requisição ou no processo de download, uma mensagem de erro é exibida.
 *
 * @param {Object} data - Os dados necessários para gerar o DANFE. Este objeto pode incluir informações como o número da NFe, série, etc.
 * @param {string} chave - A chave da Nota Fiscal Eletrônica (NFe) utilizada para nomear o arquivo PDF. 
 * @returns {Promise<void>} - Retorna uma promessa que resolve quando o processo de download for completado ou se ocorrer um erro.
 *
 */
  async downloadDanfeResultados(operacao: string, data: any, chave: string, empresa?: IEmpresa) {

    try {

      localStorage.removeItem("69d3b5564533936abc4fde43")

      let resp = await apiOperacao(operacao).post(`/${operacao}/danfe-download`, data);

      if (resp.status == 200 && data.tipo === "NFS-E") {

        toast.success("Solicitação de DANFSe realizada com sucesso!", {});

        var values = JSON.stringify({
          empresa
        });

        localStorage.setItem("69d3b5564533936abc4fde43", values);

        window.open("/nfes", "_blank")

      } else if (resp.status == 200) {

        let linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${chave}.pdf`;
        downloadLink.click();

      } else {

        toast.error(utils.decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      utils.toast_error(ex, `Erro ao baixar DANFE, tente novamente mais tarde.`);

    }

  }

  private formatDate(data) {

    const splited = data.split("-").reverse().join("-")

    return splited

  }

  private nameFile(documento, empresa, modelo) {

    const razao_social = empresa.replace(/\ /g, "_")
    const cnpj = documento["empresa"]
    const date1 = this.formatDate(documento["data1"])
    const date2 = this.formatDate(documento["data2"])

    const entrada_saida = documento["filtro"].replace("í", "i").toUpperCase()

    const tipo = documento["tipo"].replace("-", "").toUpperCase()

    return `${razao_social}-${cnpj}-${date1}-${date2}-${tipo}-${entrada_saida}${modelo}.zip`

  }

}

export const XmlService = new _XmlService();
